import React from 'react';
import {MESSAGE_SUCCESS} from "../constants";
import {sendMessage} from "../actions";
import {useDispatch} from "react-redux";

export default function useSuccessMessage() {
    const dispatch = useDispatch();

    return message => dispatch(sendMessage(MESSAGE_SUCCESS, message));
}